import { render, staticRenderFns } from "./RankForm.vue?vue&type=template&id=7b120de3&scoped=true"
import script from "./RankForm.vue?vue&type=script&lang=js"
export * from "./RankForm.vue?vue&type=script&lang=js"
import style0 from "./RankForm.vue?vue&type=style&index=0&id=7b120de3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b120de3",
  null
  
)

export default component.exports